import { render, staticRenderFns } from "./BecomeSupplier.vue?vue&type=template&id=12a1e10a&scoped=true&"
import script from "./BecomeSupplier.vue?vue&type=script&lang=js&"
export * from "./BecomeSupplier.vue?vue&type=script&lang=js&"
import style0 from "./BecomeSupplier.vue?vue&type=style&index=0&id=12a1e10a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a1e10a",
  null
  
)

export default component.exports